import { render } from "./Basic.vue?vue&type=template&id=31c4906f"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"
script.render = render

export default script